import { render, staticRenderFns } from "./top-lang.vue?vue&type=template&id=ee1d0842&scoped=true"
import script from "./top-lang.vue?vue&type=script&lang=js"
export * from "./top-lang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee1d0842",
  null
  
)

export default component.exports